import { gql } from "@apollo/client";

export const GET_LAST_UNREAD_HELP_COMMENT_OF_EACH_ORDER = gql`
  query GetHelpMsgSliceByOrder($args: HelpMessageInput!) {
    getHelpMsgSliceByOrder(args: $args) {
      notification {
        id
        createdAt
        order {
          orderReference
          id
          status
          patient {
            firstName
            lastName
          }
        }
        files {
          key
        }
        comment
        read
      }
      count
    }
  }
`;

export const GET_NUMBER_OF_NOTIFICATIONS = gql`
  query GetNotificationCount {
    getNotificationCount {
      helpNotification
      chatNotification
      orderDesignNotification
      designReviewNotification
    }
  }
`;

export const MARK_HELP_MESSAGES_AS_READ = gql`
  mutation MarkHelpMessagesAsRead($orderId: String!) {
    markHelpMessagesAsRead(orderId: $orderId)
  }
`;
